import React, { useEffect, useState } from "react";
import loadConfig from "../../Services/apiService";
import { useDispatch, useSelector } from "react-redux";
import InputAHSF from "../../Components/InputAHSF";
import { ValidationAllPageReports } from "../../Redux/Reducers/ReportStage/ValidateReportStage";
import {
  GetAllPR_InformationAppByPR_ReportsStagesGuid,
  GetSpecificRowNoteInformationApp,
  UpdatePR_InformationApp,
} from "../../Redux/Reducers/ReportStage/InformationApp";
import { useParams } from "react-router-dom";
import { decryptToken } from "../../Services/Account/EncryptionParams";

const InformationAppPage = (props) => {
  const reportStageGuid=useSelector((state)=>state.Stages.reportStageGuid)
  const [jsonData, setJsonData] = useState();
  const [InformationAppList, setInformationAppList] = useState([]);
  const [Refresh, setRefresh] = useState(0);
  const getJsonData = async () => {
    let jsonData = await loadConfig();
    setJsonData(jsonData);
  };

  useEffect(() => {
    getJsonData();
  }, []);

  const dispatch = useDispatch(); // Used to dispatch Redux actions.
  const state = useSelector((state) => {
    return {
      ValidateReportStage: state.ValidateReportStage.ValidateReportStage,
      OneSpecificRowNoteInformationApp:
        state.InformationApp.OneSpecificRowNoteInformationApp,
    };
  });

  const getData = async () => {
    let data = await dispatch(
      GetAllPR_InformationAppByPR_ReportsStagesGuid({
        specificOrMulti: true,
        stageGuid: props.pR_ReportsStagesGuid,
        reportGuid: props.reportId,
        applicationInfoGuid: "string"
      })
    );
    if (data?.payload.length) {
      setInformationAppList(data?.payload);
    }
  };

  useEffect(() => {
    getData();
  }, [Refresh,reportStageGuid]);

  const UpdateApp = async (column, ios, andriod) => {
    const update = await dispatch(
      UpdatePR_InformationApp({
        pR_InformationAppId: column.pR_InformationAppId,
        pR_InformationAppNameId: column.pR_InformationAppNameId,
        ios: ios == "" ? null : ios,
        andriod: andriod == "" ? null : andriod,
        total: column.total,
        pR_ReportsStagesGuid: column.pR_ReportsStagesGuid,
      })
    );
    if (update.payload == "success") {
      setRefresh(Refresh + 1);
    }
  };

  let { stageGuid } = useParams();

  stageGuid = decryptToken(stageGuid);
 
  console.log(props.canEdit);
  
  return (
    <>
      <div id="EvaluationInformationId" className="ContinerMarks-section">
        <p className="title">
          {jsonData?.InformationAboutTheApplication?.nameAR}
        </p>
        <div className="ContinerTableYesNo">
          <table>
            <thead>
              <tr key="3">
                <th>{jsonData?.RequiredInformation?.nameAR}</th>
                <th>IOS</th>
                <th>Andriod</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              {InformationAppList &&
                InformationAppList.map((elem, index) => {
                  return (
                    <>
                      <tr key={elem.pR_InformationAppId}>
                        <td>{elem.informationAppName}</td>

                        <td>
                          <InputAHSF
                            fieldsName="yesNoTableDropDown"
                            type="number"
                            show={true}
                            disabled={
                              !props.canEdit
                            }
                            hidelable={true}
                            className="form_control_input"
                            defaultValue={elem.ios}
                            style={{ width: "100%" }}
                            onChange={async (e) => {
                              await UpdateApp(
                                elem,
                                e.target.value,
                                elem.andriod
                              );
                            }}
                            onBlur={async (e) => {
                              await UpdateApp(
                                elem,
                                e.target.value,
                                elem.andriod
                              );
                            }}
                            showValidationMessage={
                              state.ValidateReportStage
                                ? state.ValidateReportStage.includes(
                                    `IOS` + elem.pR_InformationAppId
                                  )
                                : false
                            }
                            validationMessage="حقل اجباري"
                          />
                        </td>
                        <td>
                          <InputAHSF
                            fieldsName="yesNoTableDropDown"
                            type="number"
                            show={true}
                            disabled={
                             !props.canEdit
                            }
                            hidelable={true}
                            className="form_control_input"
                            defaultValue={elem.andriod}
                            style={{ width: "100%" }}
                            onChange={async (e) => {
                              await UpdateApp(elem, elem.ios, e.target.value);
                            }}
                            onBlur={async (e) => {
                              await UpdateApp(elem, elem.ios, e.target.value);
                            }}
                            showValidationMessage={
                              state.ValidateReportStage
                                ? state.ValidateReportStage.includes(
                                    `Andriod` + elem.pR_InformationAppId
                                  )
                                : false
                            }
                            validationMessage="حقل اجباري"
                          />
                        </td>
                        <td>{elem.total}</td>
                      </tr>
                    </>
                  );
                })}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default InformationAppPage;
